<template>
  <v-dialog
    v-model="dialog"
    persistent
    width="1024"
    @click:outside="dialog = false"
  >
    <template #activator="{ props }">
      <v-btn color="grey-darken-3" variant="tonal" v-bind="props" class="ml-2"
        >Charters</v-btn
      >
    </template>

    <v-card>
      <v-card-title>
        <div class="d-flex justify-space-between">
          <span class="text-h5">Charters Associados</span>
          <v-btn
            variant="plain"
            rounded="xl"
            prepend-icon="mdi-window-close"
            @click="dialog = false"
          ></v-btn>
        </div>
      </v-card-title>

      <v-table
        class="ma-8 usecase--table"
        style="background: transparent"
        fixed-header="true"
        density="comfortable"
        ><thead class="text-grey">
          <tr>
            <th class="text-left text-grey">Objetivo</th>

            <th
              style="border-left: thin solid #efefef"
              class="text-Left text-grey"
            >
              Status do Charter
            </th>
          </tr>
        </thead>

        <tbody>
          <tr v-for="item in charters" :key="item">
            <td class="text-left">
              <RouterLink
                :to="
                  '/projects/' +
                  this.$route.params.idProjeto +
                  '/Charters/' +
                  item.id_charter
                "
                >{{ item.objetivo }}</RouterLink
              >
            </td>

            <td style="border-left: thin solid #efefef" class="text-left">
              {{ item.status_charter }}
            </td>
          </tr>
        </tbody>
      </v-table>
    </v-card>

    <v-container
      v-if="this.isLoading"
      class="d-flex justify-center align-center"
    >
      <v-progress-circular class="text-center" indeterminate size="20" />
    </v-container>
  </v-dialog>
</template>
<script>
/**
 * @module ModalListCharters
 * @desc Modal que modifica o status do CSU.
 * @vue-data {boolean} [dialog=false] - Flag que indica se o diálogo
 * está aberto ou fechado.
 * @vue-data {Array} [charters=[]] - lista de charters.
 * @vue-data {boolean} [isLoading=false] - Flag que indica se os
 * charters estão sendo carregados.
 */
import axios from 'axios';

import store from '@/store/store';
const apiUrl = process.env.VUE_APP_API_URL;

export default {
  name: 'TabelaUseCases',
  components: {},
  props: {
    id: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      dialog: false,
      charters: [],
      isLoading: false,
    };
  },
  mounted() {
    this.getChartersByCSU(this.id);
    window.addEventListener('keydown', this.handleKeyDown);
  },
  beforeUnmount() {
    window.removeEventListener('keydown', this.handleKeyDown);
  },
  methods: {
    /**
     * Lida com o evento de pressionar tecla. Se a tecla pressionada for ESC,
     * o modal é fechado.
     *
     * @param {Object} event Objeto do evento
     */
    handleKeyDown(event) {
      if (event.key === 'Escape') {
        this.dialog = false;
      }
    },

    /**
     * Pega os charter dado um CSU.
     *
     * @param {Number} id O id do caso de uso
     */
    async getChartersByCSU(id) {
      this.isLoading = true;
      axios
        .get(`${apiUrl}/api/v1/Charters/csu/${id}`, {
          headers: {
            Authorization: `Bearer ${store.state.token}`,
          },
        })
        .then((res) => {
          this.isLoading = false;
          this.charters = res.data.charters;
        });
    },
  },
};
</script>
